
export const tableHolidayDepartment = [
	{ width: '34px', isCheckbox: true, isCheckboxAll: true, isCheckboxTotal: true },
	{
		text: "ID",
		value: "id",
		width: '80px',
		func: false,
		sortable: false,
	},
	{
		text: "Name",
		value: "name",
		func: false,
		sortable: false,
		footer: "count",
	}
];
export const tabContactsTypesTable = [
	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Contact type",
		value: "name",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Parent",
		value: "parent",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit contact type',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete contact type',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const tabHolidaysTable = [
	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		width: '120px',
		settings: true,
		text: "Date",
		value: "date",
		func: false,
		sortable: false,
		align: 'center',
	},
	{
		settings: true,
		text: "Holiday name",
		value: "name",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit holiday',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete holiday',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const tabInventoryTable = [
	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Inventory type name",
		value: "name",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Parent",
		value: "parent",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit inventory',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete inventory',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const tabNotificationsTable = [

	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Title",
		value: "title",
		func: false,
		sortable: true,
	},
	{
		width: '120px',
		settings: true,
		text: "Date from",
		value: "from",
		func: false,
		sortable: false,
		align: 'center',
	},
	{
		width: '120px',
		settings: true,
		text: "Date to",
		value: "to",
		func: false,
		sortable: false,
		align: 'center',
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit inventory',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete inventory',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const tabVersionsTable = [
	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Inventory type name",
		value: "name",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Parent",
		value: "parent",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit inventory',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete inventory',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
// color
// 		:
// 		"#42A5F5FF"
// head
// 		:
// 		"Maksym Shelest"
// id
// 		:
// 		11
// name
// 		:
// 		"IT"
export const tabDepartmentsTable = [
	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Department",
		value: "name",
		func: false,
		sortable: true,
		statusColor: true,
	},
	{
		settings: true,
		text: "Head",
		value: "head",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Super head",
		value: "super_head",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit department',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete department',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const tabPositionsTable = [
	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Position",
		value: "name",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Department",
		value: "department",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit position',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete position',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const tabDocumentsTypesTable = [
	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Documents type name",
		value: "name",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit documents type',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete documents type',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const tabCompaniesTable = [
	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Company name",
		value: "name",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit documents type',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete documents type',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];

export const tabOfficeTable = [
	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "office_id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Office name",
		value: "name",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Office location",
		value: "location",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit office',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete office',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];

export const tabScheduleTable = [
	{
		width: '80px',
		settings: true,
		text: "ID",
		value: "id",
		func: false,
		sortable: true,
		footer: "count",
	},
	{
		width: '80px',
		settings: true,
		text: "Status",
		value: "status",
		func: false,
		sortable: true,
		align: 'center',
		isStatus: true,
	},
	{
		settings: true,
		text: "Name",
		value: "name",
		func: false,
		sortable: true,
	},
	{
		width: '80px',
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit1',
				text: 'Edit schedule',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete1',
				text: 'Delete schedule',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},

];

export const TITLE = {
	REMOVE_THIS_RECORD: 'Remove this record?',
	REMOVE_SCHEDULE: 'Remove schedule',
	REMOVE_HOLIDAYS: 'Remove holidays',
	REMOVE_OFFICE: 'Remove office',
	REMOVE_INVENTORY: 'Remove inventory',
	REMOVE_DEPARTMENTS: 'Remove departments',
	REMOVE_POSITIONS: 'Remove positions',
	REMOVE_DOCUMENTS_TYPES: 'Remove documents type',
	REMOVE_COMPANIES: 'Remove company',
	REMOVE_CONTACTS_TYPES: 'Remove contacts type',
	REMOVE_SALARY_PAYMENT: 'Remove salary payment',
	REMOVE_PAYMENT: 'Remove payment',
	REMOVE_STATEMENTS: 'Remove statements',
	REMOVE_VERSION: 'Remove version',
	REMOVE_CUSTOMER_PAYMENTS: 'Remove customer payment',
	REMOVE_LOST_PAYMENTS: 'Remove lost payment',
	REMOVE_CUSTOMER_INVOICE_ITEMS: 'Remove customer invoice item',
};
export const TEXT = {
	REMOVE_THIS_RECORD: 'Are you sure you want to remove this record? 🤔',
	REMOVE_SCHEDULE: 'Are you sure you want to remove this schedule? 🤔',
	REMOVE_HOLIDAYS: 'Are you sure you want to remove this holidays? 🤔',
	REMOVE_OFFICE: 'Are you sure you want to remove this office? 🤔',
	REMOVE_INVENTORY: 'Are you sure you want to remove this inventory? 🤔',
	REMOVE_DEPARTMENTS: 'Are you sure you want to remove this departments? 🤔',
	REMOVE_POSITIONS: 'Are you sure you want to remove this positions? 🤔',
	REMOVE_DOCUMENTS_TYPES: 'Are you sure you want to remove this documents type? 🤔',
	REMOVE_COMPANIES: 'Are you sure you want to remove this company? 🤔',
	REMOVE_CONTACTS_TYPES: 'Are you sure you want to remove this contacts type? 🤔',
	REMOVE_SALARY_PAYMENT: 'Are you sure you want to remove this salary payment? 🤔',
	REMOVE_PAYMENT: 'Are you sure you want to remove this payment? 🤔',
	REMOVE_STATEMENTS: 'Are you sure you want to remove this statements? 🤔',
	REMOVE_VERSION: 'Are you sure you want to remove this version? 🤔',
	REMOVE_CUSTOMER_PAYMENTS: 'Are you sure you want to remove this customer payment? 🤔',
	REMOVE_LOST_PAYMENTS: 'Are you sure you want to remove this lost payment? 🤔',
	REMOVE_CUSTOMER_INVOICE_ITEMS: 'Are you sure you want to remove this customer invoice item? 🤔',
};
